export const fetchConfigurationsListUrl = `/configurations`;
export const fetchConfigurationsCreateUrl = `/configurations`;
export const fetchConfigurationsTypesListUrl = `/configurations/list/filters`;
export const fetchConfigurationsInfoUrl = `/configurations`;
export const fetchConfigurationsCancelUrl = `/configurations`;
export const fetchConfigurationsUpdateUrl = `/configurations`;
